import type { AudioLevel } from '../../../store/appStore';
import './MuteToggleButton.css';

export type MuteToggleButtonProps = {
  level: AudioLevel;
  onClick?: () => void;
  /** Hub map placement under tickets in the top HUD bar. */
  variant?: 'pause' | 'map';
};

/** Sound level cycle control (0–3). Pause and map share the same chrome. */
export function MuteToggleButton({
  level,
  onClick,
  variant = 'pause',
}: MuteToggleButtonProps) {
  const isMap = variant === 'map';

  return (
    <button
      type="button"
      className={[
        'pause-mute-toggle',
        isMap ? 'pause-mute-toggle--map' : null,
        level === 0 ? 'pause-mute-toggle--muted' : null,
      ]
        .filter(Boolean)
        .join(' ')}
      aria-label={`Громкость звука: ${level}`}
      onClick={onClick}
    >
      {`Звук: ${level}`}
    </button>
  );
}
